import user from "./user";
import game from "./service";
import app from "./app";
export default {
  ...user,
  ...game,
  ...app
};
